import React from "react"
import * as svg from "./svg"

export const sparkle = (props: svg.SVGProps) => {
	const { fill, stroke, ...rest } = props
	return (
		<svg.SVG
			width="18"
			height="18"
			viewBox="0 0 18 18"
			xmlns="http://www.w3.org/2000/svg"
			fill={fill || "#9cdcfe"}
			stroke="none"
			{...rest}
		>
			<path d="M9 1l1.76 5.24L16 8l-5.24 1.76L9 15l-1.76-5.24L2 8l5.24-1.76L9 1z" />
			<path d="M15 3l.7 2.3L18 6l-2.3.7L15 9l-.7-2.3L12 6l2.3-.7L15 3z" opacity="0.6" />
		</svg.SVG>
	)
}
